module.exports = __webpack_public_path__ + "img/e_3_13_r.7b37b5a4.png";